import { Environment } from './type';
import common from './common';

export const environment: Environment = {
  ...common,
  production: false,
  provider: 'real',
  apiBaseUrl: 'https://api-dev.netpark.com.br/api/dashboard-recruiter',
  adAuthBaseUrl: 'https://api-dev.netpark.com.br/api',
  redirectAdBaseUrl: 'http://localhost:4200',
};
